import React, {useEffect, useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import SaveComponent from "./SaveComponent";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import {Form} from "react-bootstrap";
import * as UserService from "../../api/UserService";
import Style from "../Style.module.css";
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import {useTranslation} from "react-i18next";


function MentorPasswordChange(props) {
    const [oldPassword, setOldPassword] = useState(undefined)
    const [newPassword, setNewPassword] = useState(undefined)
    const [newPassRepeat, setNewPassRepeat] = useState(undefined)
    const [passDoNotMatch, setPassDoNotMatch] = useState(true)
    const [savingDisabled, setSavingDisabled] = useState(true)
    const [saved, setSaved] = useState(false)
    const [oldPassValid, setOldPassValid] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'mentorPasswordChange' });

    function handleOldPass(event) {
        let val = event.target.value
        setOldPassword(val)
        if (val === "" || val === undefined) {
            setOldPassValid(false)
        } else {
            setOldPassValid(true)
        }
        if (newPassword === undefined && newPassRepeat === undefined) {
            setPassDoNotMatch(true)
        }
    }

    function handleNewPassword(event) {
        const val = event.target.value
        setNewPassword(val)
        if ((val === "" || val === undefined) || val !== newPassRepeat) {
            setPassDoNotMatch(true)
        } else {
            setPassDoNotMatch(false)
        }
    }

    function handlePasswordRepeat(event) {
        const val = event.target.value
        setNewPassRepeat(val)
        if ((val === "" || val === undefined) || val !== newPassword) {
            setPassDoNotMatch(true)
        } else {
            setPassDoNotMatch(false)
        }
    }

    function handleSave() {
        setSavingDisabled(true)
        UserService.changePassword(
            oldPassword,
            newPassword,
            () => {
                setSaved(true)
                trySetTimeout(() => {
                    clearInputs()
                    setSaved(false)
                }, 1500)
            },
            () => {
                window.alert("failed to change")
                setSavingDisabled(false)
                setSaved(false)
            }
        )

        function clearInputs() {
            document.getElementById("change_password_form_id").reset()
            setOldPassword(undefined)
            setNewPassword(undefined)
            setNewPassRepeat(undefined)
        }
    }

    useEffect(() => {
            if (oldPassValid && !passDoNotMatch) {
                setSavingDisabled(false)
            } else {
                setSavingDisabled(true)
            }
        },
        [oldPassValid, passDoNotMatch])

    useEffectOnce(() => {
        setPassDoNotMatch(false)
    })

    return <div className={`${cabinetStyle.commonTile} ${cabinetStyle.profileSecurityPage}`}>
                <div className={cabinetStyle.profileTopRow}>
                    <div className={Style.h5Heading}>{t('changePassword')}</div>
                    <div className={cabinetStyle.profileEditControls}>
                        {saved &&
                            <div className={cabinetStyle.controlsSaved}>
                                <CheckBoxOutlinedIcon fontSize={"large"}></CheckBoxOutlinedIcon>
                            </div>
                            }
                        {!saved &&
                            <SaveComponent disabled={savingDisabled} actOnClick={handleSave}
                                           toolTipText={t('saveButton')}></SaveComponent>}
                    </div>
                </div>
                <div className={cabinetStyle.profileBody}>
                    <Form id={"change_password_form_id"}>
                        <Form.Group className={cabinetStyle.changePasswordElement}>
                            <Form.Label>{t('oldPassword')}</Form.Label>
                            <Form.Control
                                style={{
                                    backgroundColor: "white",
                                    marginBottom: "24px",
                                    marginLeft: "16px",
                                }}
                                as="input"
                                type="password"
                                onChange={e => handleOldPass(e)}
                            />
                            <Form.Label>{t('newPassword')}</Form.Label>
                            <Form.Control
                                style={{
                                    backgroundColor: "white",
                                    marginBottom: "24px",
                                    marginLeft: "16px",
                                }}
                                as="input"
                                type="password"
                                onChange={e => handleNewPassword(e)}
                            />
                            <Form.Label>{t('repeatNewPassword')}</Form.Label>
                            <Form.Control
                                style={{
                                    backgroundColor: "white",
                                    marginBottom: "0px",
                                    marginLeft: "16px",
                                }}
                                as="input"
                                type="password"
                                onChange={e => handlePasswordRepeat(e)}
                            />
                            <div/>
                            {passDoNotMatch &&
                                <small style={{color: "red", marginLeft: "16px",}}>{t('passwordsDoNotMatch')}</small>}

                        </Form.Group>
                    </Form>
                </div>
        </div>

}

export default MentorPasswordChange
